/* import __COLOCATED_TEMPLATE__ from './location-warning-modal-body.hbs'; */
import templateOnly from '@ember/component/template-only';
export default templateOnly();